import { render, staticRenderFns } from "./Final.vue?vue&type=template&id=207fce14&scoped=true&"
import script from "./Final.vue?vue&type=script&lang=js&"
export * from "./Final.vue?vue&type=script&lang=js&"
import style0 from "./Final.vue?vue&type=style&index=0&id=207fce14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207fce14",
  null
  
)

export default component.exports